<template>
  <v-slide-y-transition>
    <main class="password modal" v-if="visibility">
      <section class="password__card">
        <Header />
        <component :is="step" />
      </section>
    </main>
  </v-slide-y-transition>
</template>

<script>
import Header from "./header/Header.vue";
import Email from "./steps/Email.vue";
import Token from "./steps/Token.vue";
import Passwords from "./steps/Passwords.vue";
import Finish from "./steps/Finish.vue";
import { mapGetters } from "vuex";

export default {
  name: "PasswordComponent",

  computed: {
    ...mapGetters({
      step: "getPasswordStep",
      visibility: "getPasswordModalStatus",
    }),
  },

  components: {
    Header,
    Email,
    Token,
    Passwords,
    Finish,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.password {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;

  .password__card {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 25px;

    width: 360px;
    min-height: 300px;
    padding: 25px;
    border-radius: 15px;
    background: #ffffff;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
  }
}
</style>
